export const confirmsCaptionRemoval = (hasSignature: boolean, caption: string | null): boolean =>
	hasSignature && !!caption?.trim();

const toggleSignature = (
	prev: boolean,
	input: HTMLInputElement,
	updateAttributes: (attributes: { title: string }) => void,
): boolean => {
	const newValue = !prev;

	if (newValue) {
		input.focus();
	} else {
		input.blur();
		input.value = "";
		updateAttributes({ title: "" });
	}

	return newValue;
};

export default toggleSignature;
